import {
  deleteHospitalization,
  hospitalizationDetailsSectionEmptyObject,
  ICaseDetailsInputs,
  postHospitalization,
} from 'API';
import { AddPaperCard, FormSection } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { IndexContext, IndexProvider } from 'Modules/CaseDetails/CaseContext';
import { MedicalFacilityCard } from 'Modules/CaseDetails/MedicalFacilityCard';
import { useContext, useEffect, useState } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

export const InjuriesDetails = () => {
  const { index } = useContext(IndexContext);

  const baseName = `caseDetails.${index}`;

  const { getValues } = useFormContext<ICaseDetailsInputs>();

  const [currentOpenInjuryDetailCard, setCurrentOpenInjuryDetailCard] =
    useState<number>(0);

  const { remove, append, fields } = useFieldArray<
    ICaseDetailsInputs,
    'caseDetails.0.hospitalizationDetailsSection',
    'rid'
  >({
    name: `${baseName}.hospitalizationDetailsSection` as 'caseDetails.0.hospitalizationDetailsSection',
    keyName: 'rid',
  });

  useEffect(() => {
    if (fields.length === 0) onAddHospitalizationHandler();
  }, [fields.length]);

  const onAddHospitalizationHandler = async () => {
    const id = getValues(`caseDetails.${index}.id`);
    const hospitalizationDetailsSection = await postHospitalization(id);
    if (hospitalizationDetailsSection) {
      append({
        ...hospitalizationDetailsSectionEmptyObject,
        id: hospitalizationDetailsSection.id,
      });
    }
  };

  const deleteHospitalizationHandler = async (
    hospitalizationIndex: number,
    hospitalizationId: number
  ) => {
    const id = getValues(`caseDetails.${index}.id`);
    const deleteHospital = await deleteHospitalization(id, hospitalizationId);

    if (deleteHospital) {
      remove(hospitalizationIndex);
      setCurrentOpenInjuryDetailCard(currentOpenInjuryDetailCard - 1);
    }
  };

  return (
    <FormSection disablePadding>
      {fields.map((field, index) => (
        <IndexProvider
          key={index}
          index={index}
          baseName={`${baseName}.hospitalizationDetailsSection`}
        >
          <MedicalFacilityCard
            key={field.id}
            index={index}
            hospitalizationId={field.id || 0}
            deleteFacility={() =>
              deleteHospitalizationHandler(index, field.id || 0)
            }
            isOpen={currentOpenInjuryDetailCard === index}
            setCurrentOpenInjuryDetailCard={setCurrentOpenInjuryDetailCard}
          />
        </IndexProvider>
      ))}
      <AddPaperCard
        label={Dictionary[DICTIONARY.CASE_DETAILS].fifthSectionAddTreatment}
        add={() => {
          onAddHospitalizationHandler();
          setCurrentOpenInjuryDetailCard(currentOpenInjuryDetailCard + 1);
        }}
      />
    </FormSection>
  );
};
